module.exports = "pegasus_template/assets/badges-card.png";